import { render, staticRenderFns } from "./AreaColor.vue?vue&type=template&id=ea782aa8&scoped=true"
import script from "./AreaColor.vue?vue&type=script&lang=js"
export * from "./AreaColor.vue?vue&type=script&lang=js"
import style0 from "./AreaColor.vue?vue&type=style&index=0&id=ea782aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea782aa8",
  null
  
)

export default component.exports